import { useState, useEffect, useRef } from 'react';
import { withWindow } from '@shared/utils/withWindow';
import { withGoogleMaps } from '@static/js/googleMaps';

const extractLibraryFromWindow = () => withWindow(global => global.google?.maps || null, null);

export const useGoogleMaps = (): [typeof google.maps | null, { loading: boolean }] => {
  const [loadingGoogleMaps, setLoadingGoogleMaps] = useState(true);
  const googleMapsRef = useRef<typeof google.maps | null>(extractLibraryFromWindow());

  useEffect(() => {
    const googleMaps = extractLibraryFromWindow();

    if (googleMaps) {
      googleMapsRef.current = googleMaps;
      setLoadingGoogleMaps(false);
      return;
    }

    const loadGoogleMaps = () => {
      withGoogleMaps(googleMapsLoaded => {
        googleMapsRef.current = googleMapsLoaded;
        setLoadingGoogleMaps(false);
      });
    };

    loadGoogleMaps();
  }, []);

  return [googleMapsRef.current, { loading: loadingGoogleMaps }];
};
